var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.041 31.188L31.3995 41.3067L31.934 42.1044L32.4245 43.3684C32.4331 43.4001 32.4484 43.4357 32.4676 43.4646C32.7437 44.1052 32.7282 44.8648 32.3543 45.517C31.7249 46.6149 30.3073 46.9704 29.2439 46.3608L29.0489 46.249C29.0825 46.2683 29.1161 46.2875 29.1536 46.3001L4.79006 32.3341C4.81982 32.3601 4.85347 32.3794 4.88709 32.3987L4.69205 32.2869C3.68212 31.708 3.19411 30.3334 3.85503 29.1804C4.48336 28.0843 5.87313 27.7016 6.96253 28.3261L7.66865 28.7308L10.5246 20.5223C12.297 18.0538 13.1002 14.8602 12.3639 11.9364C13.273 11.5195 14.5375 11.3866 14.5375 11.3866L15.0404 12.6756L15.1229 12.8747C15.3221 13.3999 15.2838 14.0122 14.9831 14.5368C14.7557 14.9335 14.4197 15.2234 14.0215 15.3883L16.8011 23.1016L29.6626 14.848C29.181 14.0984 29.1237 13.0918 29.6017 12.2579C30.2879 11.0609 33.5679 11.2615 33.5679 11.2615L34.0067 12.3975L34.0317 12.4476L34.1495 12.7563C34.3524 13.3998 34.2976 14.1188 33.9391 14.7443C33.4611 15.5781 32.5635 16.0374 31.6666 15.9968L31.6627 16.0035L31.0574 31.2738L39.1113 29.7705C39.0523 29.3436 39.126 28.9033 39.3534 28.5066C39.8854 27.5786 42.3537 27.3406 42.3537 27.3406L42.9237 28.7931L42.939 28.8287C43.1277 29.3568 43.0865 29.9586 42.7897 30.4764C42.2462 31.4246 41.0363 31.7585 40.0881 31.2149L40.041 31.188Z",
    fill: "#F16522"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4955 29.8422L31.207 12.0781L18.4316 34.3649L21.7967 36.2938L30.4955 29.8422Z",
    fill: "url(#paint0_linear_158_1660)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2065 12.0783L16.2431 21.6727L15.0661 32.4361L18.4311 34.365L31.2065 12.0783Z",
    fill: "url(#paint1_linear_158_1660)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8388 33.2933L21.7974 36.2942L18.4319 34.365L26.979 19.4546L25.8388 33.2933Z",
    fill: "url(#paint2_linear_158_1660)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2383 33.7393L21.797 36.2946L18.4315 34.3654L25.9692 21.2158L25.2383 33.7393Z",
    fill: "url(#paint3_linear_158_1660)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.611 27.4352L26.9787 19.4549L18.4316 34.3652L15.067 32.4365L15.611 27.4352Z",
    fill: "url(#paint4_linear_158_1660)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.966 21.2155L18.4293 34.3633L15.0625 32.4334L15.5303 28.1744L25.966 21.2155Z",
    fill: "url(#paint5_linear_158_1660)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0909 27.8666L30.4951 29.8418L21.7962 36.2935L26.1235 38.774L34.4023 31.9333L41.0909 27.8666Z",
    fill: "url(#paint6_linear_158_1660)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0907 27.8666L34.4021 31.9334L26.1233 38.774L29.9219 40.9515L41.0907 27.8666Z",
    fill: "url(#paint7_linear_158_1660)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4025 31.9333L25.8374 33.3006L25.8372 33.2966L21.7964 36.2935L26.1237 38.774L34.4025 31.9333Z",
    fill: "url(#paint8_linear_158_1660)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5988 32.5915L26.122 38.7723L21.7971 36.2931L25.2403 33.7407L33.5988 32.5915Z",
    fill: "url(#paint9_linear_158_1660)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5864 11.5273L16.2424 21.6721L15.0653 32.4355L10.7381 29.9549L12.4573 19.3541L12.5864 11.5273Z",
    fill: "url(#paint10_linear_158_1660)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5864 11.5275L12.4573 19.3543L10.7381 29.9551L6.93952 27.7776L12.5864 11.5275Z",
    fill: "url(#paint11_linear_158_1660)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4575 19.3545L15.606 27.4364L15.6096 27.4345L15.0656 32.4358L10.7383 29.9553L12.4575 19.3545Z",
    fill: "url(#paint12_linear_158_1660)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2969 20.3804L10.7419 29.9557L15.0668 32.4349L15.5292 28.1738L12.2969 20.3804Z",
    fill: "url(#paint13_linear_158_1660)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7952 44.0803C31.1428 45.2185 29.7208 45.5179 28.6848 44.9241L4.19678 30.8868C3.10649 30.2618 2.72803 28.8667 3.35302 27.7764C3.66552 27.2312 4.17417 26.8661 4.73449 26.7141C5.2948 26.5621 5.91827 26.6202 6.46342 26.9326L30.9515 40.97C32.0418 41.595 32.4202 42.99 31.7952 44.0803Z",
    fill: "url(#paint14_linear_158_1660)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7961 44.0833C31.1703 45.175 29.7538 45.5413 28.6833 44.9277L28.488 44.8158C29.5298 45.413 30.898 45.1221 31.4975 44.0764C32.0832 43.0545 31.5356 41.9883 30.4617 41.3727L6.30138 27.5232C5.22743 26.9076 4.03069 26.9739 3.44492 27.9958C3.15391 28.5034 3.10003 29.0952 3.26776 29.6324C3.42893 30.1658 3.78746 30.6566 4.32769 30.9663C4.23468 30.8874 3.37349 30.5692 3.07534 29.4702C2.91606 28.9033 2.98108 28.292 3.2945 27.7452C3.9213 26.6518 5.31389 26.274 6.40087 26.8971L30.9517 40.9704C32.0387 41.5935 32.4229 42.9898 31.7961 44.0833Z",
    fill: "#FFFD83"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6551 21.764C24.2809 24.5661 21.3218 29.7594 19.4781 32.5399C20.9437 29.5476 23.9299 24.3684 25.6551 21.764Z",
    fill: "url(#paint15_radial_158_1660)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1106 13.9916C29.4878 15.4829 27.9708 18.1606 26.9303 19.5397C27.5937 17.9469 29.1376 15.2839 30.1106 13.9916Z",
    fill: "url(#paint16_radial_158_1660)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1241 38.7744C27.8375 37.6398 32.9382 33.4327 34.4028 31.9338C32.6526 33.0909 27.56 37.3069 26.1241 38.7744Z",
    fill: "url(#paint17_radial_158_1660)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4584 28.2516C39.0342 29.33 36.6891 30.7627 35.0345 31.5494C36.4931 30.4436 38.8437 29.0208 40.4584 28.2516Z",
    fill: "url(#paint18_radial_158_1660)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7403 29.924C10.8534 27.8721 11.9062 21.3445 12.4595 19.3232C12.3908 20.5841 11.2809 27.9434 10.7403 29.924Z",
    fill: "url(#paint19_radial_158_1660)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5762 12.2363C12.3654 14.0103 12.3142 16.7579 12.4715 18.5833C12.6886 16.7658 12.7285 14.0184 12.5762 12.2363Z",
    fill: "url(#paint20_radial_158_1660)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9218 40.949L39.9276 28.6965L29.6758 30.449L30.3997 13.4833L16.1378 22.6886L12.4571 12.9495L6.94061 27.7755L12.5872 11.5251L16.2437 21.6725L31.2065 12.0759L30.4956 29.8422L41.091 27.8643L29.9218 40.949Z",
    fill: "#FEF328"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9643 14.2432C31.1613 14.9293 32.6879 14.5152 33.3741 13.3182C34.0602 12.1212 33.6461 10.5946 32.4491 9.90842C31.2521 9.22226 29.7255 9.63638 29.0393 10.8334C28.3532 12.0304 28.7673 13.557 29.9643 14.2432Z",
    fill: "url(#paint21_linear_158_1660)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.109 13.9901C31.088 14.5513 32.3366 14.2126 32.8978 13.2336C33.459 12.2546 33.1203 11.006 32.1413 10.4448C31.1623 9.88365 29.9137 10.2223 29.3525 11.2013C28.7913 12.1803 29.13 13.4289 30.109 13.9901Z",
    fill: "url(#paint22_linear_158_1660)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5271 29.7848C40.4763 30.3289 41.687 30.0005 42.2312 29.0512C42.7753 28.1019 42.4469 26.8913 41.4976 26.3471C40.5484 25.8029 39.3377 26.1314 38.7935 27.0806C38.2494 28.0299 38.5778 29.2406 39.5271 29.7848Z",
    fill: "url(#paint23_linear_158_1660)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6423 29.5839C40.4185 30.0288 41.4085 29.7603 41.8534 28.9841C42.2984 28.2078 42.0298 27.2179 41.2536 26.7729C40.4774 26.328 39.4874 26.5965 39.0425 27.3727C38.5975 28.149 38.8661 29.1389 39.6423 29.5839Z",
    fill: "url(#paint24_linear_158_1660)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7219 13.8453C12.6712 14.3895 13.8818 14.0611 14.426 13.1118C14.9702 12.1625 14.6417 10.9518 13.6925 10.4076C12.7432 9.86349 11.5325 10.1919 10.9883 11.1412C10.4442 12.0905 10.7726 13.3012 11.7219 13.8453Z",
    fill: "url(#paint25_linear_158_1660)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8371 13.6444C12.6133 14.0894 13.6033 13.8208 14.0482 13.0446C14.4932 12.2684 14.2246 11.2784 13.4484 10.8335C12.6722 10.3885 11.6823 10.6571 11.2373 11.4333C10.7924 12.2095 11.0609 13.1995 11.8371 13.6444Z",
    fill: "url(#paint26_linear_158_1660)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_158_1660",
    x1: 10.5621,
    y1: 15.0486,
    x2: 39.0654,
    y2: 31.3875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_158_1660",
    x1: 10.5731,
    y1: 15.0553,
    x2: 39.077,
    y2: 31.3946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.136937,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848648,
    stopColor: "#FEF328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_158_1660",
    x1: 22.7056,
    y1: 26.91,
    x2: 27.8184,
    y2: 29.8408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED971A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_158_1660",
    x1: 31.5156,
    y1: 33.1304,
    x2: 12.8842,
    y2: 22.4503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_158_1660",
    x1: 17.5925,
    y1: 23.9795,
    x2: 22.7053,
    y2: 26.9103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED971A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_158_1660",
    x1: 22.1984,
    y1: 27.7895,
    x2: 17.3458,
    y2: 25.0079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.120245,
    stopColor: "#FEE825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.330162,
    stopColor: "#FCCB1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604835,
    stopColor: "#FB9D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.930612,
    stopColor: "#F85C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942343,
    stopColor: "#F85A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_158_1660",
    x1: 8.38398,
    y1: 18.8612,
    x2: 36.8872,
    y2: 35.2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.403604,
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942342,
    stopColor: "#FCA81D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_158_1660",
    x1: 16.9132,
    y1: 19.8873,
    x2: 35.4862,
    y2: 34.8323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699099,
    stopColor: "#F85A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950781,
    stopColor: "#FB9B19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA81D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_158_1660",
    x1: 24.2962,
    y1: 31.9333,
    x2: 31.9032,
    y2: 36.2938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED971A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_158_1660",
    x1: 24.055,
    y1: 32.3544,
    x2: 31.3412,
    y2: 36.5311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20877,
    stopColor: "#FEE826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573088,
    stopColor: "#FDCB22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942342,
    stopColor: "#FCA81D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_158_1660",
    x1: 36.8865,
    y1: 35.2001,
    x2: 8.38256,
    y2: 18.8607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_158_1660",
    x1: 40.805,
    y1: 37.4464,
    x2: 8.38255,
    y2: 18.8609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F85A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA81D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_158_1660",
    x1: 33.1096,
    y1: 36.986,
    x2: 9.95782,
    y2: 23.7147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED971A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_158_1660",
    x1: 17.325,
    y1: 28.4964,
    x2: 10.0388,
    y2: 24.3197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20877,
    stopColor: "#FEE826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573088,
    stopColor: "#FDCB22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942342,
    stopColor: "#FCA81D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_158_1660",
    x1: 18.7082,
    y1: 33.9514,
    x2: 16.4415,
    y2: 37.9055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED971A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_158_1660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5544 27.1741) rotate(29.8227) scale(5.07393 4.39402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_158_1660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.4605 16.8712) rotate(29.8227) scale(5.07393 2.26297)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_158_1660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.2641 35.3545) rotate(29.8227) scale(3.79653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_158_1660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.7471 29.9006) rotate(29.8227) scale(2.24397)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_158_1660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5998 24.6232) rotate(-150.177) scale(3.79653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_158_1660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.5236 15.4099) rotate(-150.177) scale(2.24397)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_158_1660",
    x1: 29.0393,
    y1: 10.8334,
    x2: 33.3747,
    y2: 13.3186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_158_1660",
    x1: 32.142,
    y1: 10.4452,
    x2: 30.1093,
    y2: 13.9911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_158_1660",
    x1: 38.7942,
    y1: 27.081,
    x2: 42.2312,
    y2: 29.0512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_158_1660",
    x1: 41.2543,
    y1: 26.7733,
    x2: 39.6426,
    y2: 29.5849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_158_1660",
    x1: 10.9883,
    y1: 11.1412,
    x2: 14.426,
    y2: 13.1118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_158_1660",
    x1: 13.4484,
    y1: 10.8335,
    x2: 11.8367,
    y2: 13.6451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.650e4e88d690e40796548712d6dabe35.svg";
export { ForwardRef as ReactComponent };